import { jsx as _jsx } from "react/jsx-runtime";
import SharedComponents from '../SharedComponents';
const Image = (props) => {
    let { renderImage } = SharedComponents.useContext();
    if (typeof renderImage === 'function') {
        return renderImage(props);
    }
    return (_jsx("img", { src: props.src, alt: props.alt, loading: props.priority == 0 ? 'eager' : 'lazy', fetchpriority: props.priority == 0 ? 'high' : 'low', style: {
            objectFit: props.fit,
            objectPosition: 'center',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0
        } }));
};
export default Image;
